module.exports = __webpack_public_path__ + "img/Off-Duty-Boots_fr.49e17364.jpg";